/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import DiscountManagementDash from "../../../components/Payments/DiscountManagement";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const DiscountManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.payments?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscountManagementDash adminConfig={userConfig?.payments} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscountManagement;
